// 引入storageClear工具函数和router文件
import { getToken, removeToken, setUserInfo, getUserInfo, removeAll } from "@/utils/auth";
import router from "@/router";

let lastTime = new Date().getTime();
let currentTime = new Date().getTime();
let timeOut = 30 * 60 * 1000; //设置超时时间: 30分钟
let userInfo = {
    roleName: "",
};

window.onload = function () {
    window.document.onmousedown = function () {
        setUserInfo("lastTime", new Date().getTime());
    };
};

function checkTimeout() {
    currentTime = new Date().getTime(); //更新当前时间
    lastTime = getUserInfo("lastTime");
    userInfo = getUserInfo("userInfo");

    if (getToken() != null && userInfo && (userInfo.roleName == "parent" || userInfo.roleName == "student")) {
        if (currentTime - lastTime > timeOut) {
            //判断是否超时

            // 清除storage的数据(登陆信息和token)
            removeToken();
            removeAll();
            window.sessionStorage.clear();
            router.push({ path: "/login" });
        }
    }
}

export default function () {
    /* 定时器 间隔30秒检测是否长时间未操作页面 */
    window.setInterval(checkTimeout, 30000);
}
